import { render, staticRenderFns } from "./BackgroundText.vue?vue&type=template&id=4ea19571&scoped=true"
import script from "./BackgroundText.vue?vue&type=script&lang=js"
export * from "./BackgroundText.vue?vue&type=script&lang=js"
import style0 from "./BackgroundText.vue?vue&type=style&index=0&id=4ea19571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea19571",
  null
  
)

export default component.exports